import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconPbs10X = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_2018_6406)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M13.5788 10.9091V21.0909H11.7344V12.7039H11.6747L9.29333 14.2252V12.5348L11.8239 10.9091H13.5788ZM17.6556 13.4546L19.1967 16.2735L20.7628 13.4546H22.6669L20.3651 17.2728L22.7067 21.0909H20.8125L19.1967 18.3416L17.5959 21.0909H15.6868L18.0135 17.2728L15.7465 13.4546H17.6556Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2018_6406",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "none"
		})
	}) })]
});
export default SvgIconPbs10X;
